module.exports = __webpack_public_path__ + "b3a1672ac017ca70d8dd3dc312177878.png";